export default "__VITE_ASSET__DYjiG$fH__"